import { useState, useEffect } from "react";
import Navbar from "../components/navbar";
import emailjs from 'emailjs-com'
import WhatsAppButton from "../components/WhatsAppButton";

const Checkout = () => {
    const [loading, setLoading] = useState(false); // ✅ Loader state

    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        phone: "",
        loanType: "",
        loanAmount: "",
        repaymentPeriod: "",
        iban: "",
        proof: null,
        bank: localStorage.getItem("bank") || "", // ✅ localStorage se set
    });

    // On mount check localStorage
    useEffect(() => {
        const savedBank = localStorage.getItem("bank");
        if (savedBank) {
            setFormData((prev) => ({ ...prev, bank: savedBank }));
        }
    }, []);

    // Handle form data change
    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "proof") {
            setFormData({ ...formData, proof: files[0] });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    // Handle submit
    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true); // ✅ Show loader

        const templateParams = {
            fullName: formData.fullName,
            email: formData.email,
            phone: formData.phone,
            loanType: formData.loanType,
            loanAmount: formData.loanAmount,
            repaymentPeriod: formData.repaymentPeriod,
            bank: formData.bank,
            iban: formData.iban,
            paymentProof: formData.proof ? formData.proof.name : "Not uploaded",
        };

        console.log("Sending params:", templateParams);

        emailjs
            .send(
                "service_vl9nbke",
                "template_vfbdhw6",
                templateParams,
                "iwxFQh5DYWtC9Y-kW"
            )
            .then((response) => {
                console.log("SUCCESS!", response.status, response.text);

                setTimeout(() => {
                    alert("✅ Order Placed & Email Sent Successfully!");

                    // ✅ Clear localStorage
                    localStorage.clear();

                    // ✅ Reset form after success
                    setFormData({
                        fullName: "",
                        email: "",
                        phone: "",
                        loanType: "",
                        loanAmount: "",
                        repaymentPeriod: "",
                        iban: "",
                        proof: null,
                        bank: "",
                    });

                    document.querySelector('input[type="file"]').value = "";

                    setLoading(false);
                }, 2000); // fake delay for loader
            })
            .catch((error) => {
                console.error("FAILED...", error);
                alert("❌ Failed to send email.");
                setLoading(false);
            });
    };

    return (
        <div>

            <Navbar />
            <section className="py-25 px-6 lg:px-12 bg-gray-50 w-full">
                <div className="max-w-3xl mx-auto bg-white shadow-lg rounded-xl p-8 mt-10">
                    <h2 className="text-3xl font-bold text-emerald-700 text-center mb-8">
                        Apply For Loan
                    </h2>

                    <form onSubmit={handleSubmit} className="space-y-6">
                        {/* ✅ Bank Name */}
                        <div>
                            <label className="block text-gray-700 font-medium mb-2">
                                Bank Name
                            </label>
                            <input
                                type="text"
                                name="bank"
                                value={formData.bank}
                                onChange={handleChange}
                                required
                                className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-emerald-500"
                                placeholder="Enter bank name"
                            />
                        </div>

                        {/* Full Name */}
                        <div>
                            <label className="block text-gray-700 font-medium mb-2">
                                Full Name
                            </label>
                            <input
                                type="text"
                                name="fullName"
                                value={formData.fullName}
                                onChange={handleChange}
                                required
                                className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-emerald-500"
                                placeholder="Enter your full name"
                            />
                        </div>

                        {/* Email */}
                        <div>
                            <label className="block text-gray-700 font-medium mb-2">
                                Email Address
                            </label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-emerald-500"
                                placeholder="Enter your email"
                            />
                        </div>

                        {/* Phone */}
                        <div>
                            <label className="block text-gray-700 font-medium mb-2">
                                Phone Number
                            </label>
                            <input
                                type="tel"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                required
                                className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-emerald-500"
                                placeholder="e.g. +971 50 123 4567"
                            />
                        </div>

                        {/* Loan Type */}
                        <div>
                            <label className="block text-gray-700 font-medium mb-2">
                                Loan Type
                            </label>
                            <select
                                name="loanType"
                                value={formData.loanType}
                                onChange={handleChange}
                                required
                                className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-emerald-500"
                            >
                                <option value="">Select Loan Type</option>
                                <option value="personal">Personal Loan</option>
                                <option value="business">Business Loan</option>
                                <option value="creditcard">Credit Card</option>
                            </select>
                        </div>

                        {/* Loan Amount */}
                        <div>
                            <label className="block text-gray-700 font-medium mb-2">
                                Loan Amount (AED)
                            </label>
                            <input
                                type="number"
                                name="loanAmount"
                                value={formData.loanAmount}
                                onChange={handleChange}
                                required
                                className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-emerald-500"
                                placeholder="Enter loan amount"
                            />
                        </div>

                        {/* Repayment Period */}
                        <div>
                            <label className="block text-gray-700 font-medium mb-2">
                                Repayment Period (Months)
                            </label>
                            <input
                                type="number"
                                name="repaymentPeriod"
                                value={formData.repaymentPeriod}
                                onChange={handleChange}
                                required
                                className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-emerald-500"
                                placeholder="e.g. 12, 24, 36"
                            />
                        </div>

                        <div>
                            {/* Bank Details Section */}
                            <div className="bg-white shadow-md rounded-xl p-6 space-y-4 border">
                                <h3 className="text-2xl font-semibold text-emerald-700 border-b pb-3">
                                    Bank Account Details
                                </h3>

                                <div>
                                    <label className="block text-gray-700 font-medium mb-2">Loan Application Fees (Advance Payment)</label>
                                    <input
                                        type="text"
                                        value="150 AED"
                                        readOnly
                                        className="w-full p-3 border rounded-lg bg-gray-100 text-gray-800 font-semibold cursor-not-allowed"
                                    />
                                </div>

                                {/* Account Holder */}
                                <div>
                                    <label className="block text-gray-700 font-medium mb-2">Account Holder</label>
                                    <input
                                        type="text"
                                        value="MARIA ROSALINDA BREVA GABRIEL"
                                        readOnly
                                        className="w-full p-3 border rounded-lg bg-gray-100 text-gray-800 font-semibold cursor-not-allowed"
                                    />
                                </div>


                                {/* Bank Name */}
                                <div>
                                    <label className="block text-gray-700 font-medium mb-2">Bank Name</label>
                                    <input
                                        type="text"
                                        value="First Abu Dhabi Bank (FAB)"
                                        readOnly
                                        className="w-full p-3 border rounded-lg bg-gray-100 text-gray-800 font-semibold cursor-not-allowed"
                                    />
                                </div>

                                {/* IBAN */}
                                <div>
                                    <label className="block text-gray-700 font-medium mb-2">IBAN</label>
                                    <div className="flex items-center gap-2">
                                        <input
                                            type="text"
                                            value="AE68 0355 6400 1305 9891 479"
                                            readOnly
                                            className="w-full p-3 border rounded-lg bg-gray-100 text-gray-800 font-semibold cursor-not-allowed"
                                        />
                                        <button
                                            type="button"
                                            onClick={() =>
                                                navigator.clipboard.writeText("AE123456789012345678901")
                                            }
                                            className="bg-emerald-500 text-white px-4 py-2 rounded-lg hover:bg-emerald-600 transition"
                                        >
                                            Copy
                                        </button>
                                    </div>
                                </div>

                                {/* Swift Code */}
                                <div>
                                    <label className="block text-gray-700 font-medium mb-2">SWIFT Code</label>
                                    <div className="flex items-center gap-2">
                                        <input
                                            type="text"
                                            value="NBADAEAA"
                                            readOnly
                                            className="w-full p-3 border rounded-lg bg-gray-100 text-gray-800 font-semibold cursor-not-allowed"
                                        />
                                        <button
                                            type="button"
                                            onClick={() => navigator.clipboard.writeText("NBADAEAA")}
                                            className="bg-emerald-500 text-white px-4 py-2 rounded-lg hover:bg-emerald-600 transition"
                                        >
                                            Copy
                                        </button>
                                    </div>
                                </div>

                                {/* Note */}
                                <p className="text-sm text-gray-600 mt-2">
                                    Please transfer your advance payment to the above account and upload proof below, <br />
                                    or you can send it on whatsapp
                                </p>
                            </div>
                        </div>
                        {/* Payment Proof Upload */}
                        <div>
                            <label className="block text-gray-700 font-medium mb-2">
                                Upload Payment Proof
                            </label>
                            <input
                                type="file"
                                name="proof"
                                accept="image/*,application/pdf"
                                onChange={handleChange}
                                required
                                className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-emerald-500"
                            />
                        </div>

                        {/* Submit */}
                        <div className="text-center">
                            <button
                                type="submit"
                                disabled={loading} // ✅ disable while loading
                                className={`px-8 py-3 rounded-full font-semibold shadow-md transition-transform ${loading
                                    ? "bg-gray-400 text-white cursor-not-allowed"
                                    : "bg-gradient-to-r from-emerald-500 to-teal-600 text-white hover:scale-105"
                                    }`}
                            >
                                {loading ? "Submitting..." : "Submit Loan Application"}
                            </button>
                        </div>
                    </form>
                    <WhatsAppButton />
                </div>
            </section>
        </div>
    );
};

export default Checkout;
